import { render, staticRenderFns } from "./NumberOfLots.vue?vue&type=template&id=6e080a25&scoped=true"
import script from "./NumberOfLots.vue?vue&type=script&lang=js"
export * from "./NumberOfLots.vue?vue&type=script&lang=js"
import style0 from "./NumberOfLots.vue?vue&type=style&index=0&id=6e080a25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e080a25",
  null
  
)

export default component.exports